import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';
const Button = ({children, href, onClick}) => {
		return (
			<Link class={style.button} onClick={onClick} href={href}>
        {children}
			</Link>
		);
}
export default Button;



// WEBPACK FOOTER //
// ./components/button/index.js